import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  public screen:number = 0;
  public id_premio:number = 0;
  constructor() { }

  ngOnInit() {
  }

  goToGame(event){
    console.log(event)
    if(event){
      this.screen = 1
    }
  }
  goToHome(event){
    console.log(event)
    if(event){
      this.screen = 0
    }
  }
  goToPremios(event){
    console.log(event)
    if(event){
      this.screen = 2
    }
  }
  goToGanadores(event){
    console.log(event)
    if(event){
      this.screen = 4
    }
  }
  goToConfig(event){
    console.log(event)
    if(event){
      this.screen = 5
    }
  }
  goToResult(event){
    this.id_premio = event
    this.screen = 3
  }

}
